import React, { useRef, useState } from 'react';
import { useField } from 'formik';

export default function FileUpload({
  onError = console.error,
  urlFieldName,
  sizeFieldName,
  accept,
  children,
  setUploading,
  maxSize,
  maxSizeError
}) {
  const [, , urlHelpers] = useField(urlFieldName);
  const [, , sizeHelpers] = useField(sizeFieldName);

  const [error, setError] = useState(null);
  const fileUpload = useRef(null);

  const onClick = () => {
    fileUpload.current.click();
  };

  const onChange = e => {
    let reader = new FileReader();
    const file = e.target.files[0];

    reader.onloadend = () => {
      urlHelpers.setValue(reader.result);
      sizeHelpers.setValue(file.size);
      setUploading(false);
    };

    const onErr = err => {
      urlHelpers.setValue('');
      sizeHelpers.setValue(0);
      setError(err);
      onError(err);
      setUploading(false);
    };

    if (file) {
      if (file.size / 1024 / 1024 <= maxSize) {
        reader.readAsDataURL(file);
        setUploading(true);
      } else {
        onErr(maxSizeError);
      }
    }
  };

  return (
    <>
      <label>
        <input
          ref={fileUpload}
          style={{ display: 'none' }}
          type="file"
          accept={accept}
          onChange={onChange}
        />
      </label>
      {children(onClick)}
      {error && <div className="input-feedback">{error}</div>}
    </>
  );
}
